
import { Vue, Options } from 'vue-class-component';
import { IModalAction } from '@/lib';
import { OrganisationDeviceService } from '@/services/api';
import { BaseCard } from '@/lib/components/Card';
import { ActionModal } from '@/lib/components/Modals';
import { BaseButton } from '@/lib/components/Button';
import useClipboard from 'vue-clipboard3';
import { useSessionStore } from '@/stores/session.store';
import { useNotificationStore } from '@/stores/notification.store';

@Options({
  props: {
    deviceId: {
      type: String,
      required: true
    }
  },
  components: {
    BaseCard,
    ActionModal,
    BaseButton
  }
})
export default class DeviceKey extends Vue {
  deviceId!: string;
  deviceKey = '**********************';
  saving = false;
  deviceKeyIsReady = false;
  deviceKeyModal = false;
  sessionStore = useSessionStore();
  notificationStore = useNotificationStore();

  get deviceKeyModalActions(): IModalAction[] {
    return [
      {
        label: this.$t('platform.device.confirm-regenerate') as string,
        color: 'primary',
        onClick: () => this.generateDeviceKey()
      },
      {
        label: this.$t('platform.common.cancel') as string,
        color: 'gray',
        onClick: () => (this.deviceKeyModal = false)
      }
    ];
  }

  get deviceService(): OrganisationDeviceService | null {
    if (this.organisationId) {
      return new OrganisationDeviceService(this.organisationId);
    }
    return null;
  }

  get organisationId(): string | null {
    if (this.$route.name === 'domain-admin-edit-device') {
      return this.$route.params.organisationId;
    } else if (this.$route.name === 'settings-edit-device') {
      return this.sessionStore.currentOrganisationId;
    }
    return null;
  }

  created() {
    this.deviceKey = this.$route.query.deviceKey ? this.$route.query.deviceKey.toString() : '**********************';
    this.deviceKeyIsReady = !!this.$route.query.copyDeviceKey;
  }

  async onCopy() {
    try {
      const { toClipboard } = useClipboard();
      await toClipboard(this.deviceKey);
      await this.notificationStore.addSuccessNotification({
        title: this.$t('platform.device.copy-key-success')
      });
    } catch (error) {
      await this.notificationStore.addErrorNotification({
        title: this.$t('platform.device.copy-key-error')
      });
    }
  }

  async generateDeviceKey() {
    try {
      if (this.deviceService) {
        this.saving = true;
        const response = await this.deviceService.generateDeviceKey(this.deviceId);
        this.deviceKey = response.key;
        this.deviceKeyIsReady = true;
        await this.notificationStore.addSuccessNotification({
          title: this.$t('platform.device.regenerate-key-success')
        });
      }
    } catch (error) {
      await this.notificationStore.addErrorNotification({
        title: this.$t('platform.device.regenerate-key-error')
      });
    } finally {
      this.saving = false;
    }
  }
}
